import { Presentation } from "../../../core/gameflow/controller/Presentation";
import { StateHandler } from '../../../core/utils/StateHandler';
import { SanEngineManager } from "../../engine/SanEngineManager";
import { SanQuentin2 } from "../../SanQuentin2";
import { GameData } from "../../server/data/GameData";
import { ZeroBetPresentation } from "../../zero/ZeroBetPresentation";
import { RevealerManager } from '../../modules/revealer/RevealerManager';
import { TranslationConfig } from "../../config/translate/TranslationConfig";
import {GameSetting} from "../../../core/setting/GameSetting";
import { SoundManager } from "../../config/sound/SoundManager";
import { SoundConfig } from "../../config/sound/SoundConfig";
enum SetupPhases {
    INTRO_PRES = "INTRO_PRES",
    CLICK = "CLICK",
    SHOW_DELAY = "SHOW_DELAY",
    SHOW_RES = "SHOW_RES",
    ROUND_WON = "ROUND_WON",
    BARS_OPEN = "BARS_OPEN",
    OUTRO = "OUTRO",
    CONVERT = "CONVERT"
}

export class FirstSetupPresentation extends Presentation {

    protected choiceValue: number = 0;
    protected _finished: boolean;

    private state = new StateHandler(undefined, new Map<String, Function>([
        [SetupPhases.SHOW_DELAY, () => this.onDelay()],
        [SetupPhases.SHOW_RES, () => this.onResult()],
        [SetupPhases.OUTRO, () => this.onNext()],
        [SetupPhases.ROUND_WON, () => this.onRoundWon()],
        [SetupPhases.CONVERT, () => this.onConvert()],
        [SetupPhases.BARS_OPEN, () => this.onOpenBars()],
    ]));

    public setGameData(data: GameData): void {
        super.setGameData(data);
        SanQuentin2.setupPhase.setData(data);

        this.state.set(SetupPhases.SHOW_DELAY);
        this._finished = data.gameModeChanges;

        if(this._finished){
            SanEngineManager.parseData(data.Reel)
            if(ZeroBetPresentation.pickedZeroValue == 1)
                this.state.set(SetupPhases.OUTRO);
        }
    }

    public createPresentation(skip:Function): void {
        this.state.triggerState(skip);
    }

    public onDelay():void{
        this.state.set(SetupPhases.SHOW_RES);
        if(this._gameData.isRestoreState || GameSetting.replayMode) return;
        this.timeline.to(this,{ duration:this._gameData.raw.currenSetupLevel * 0.35});
    }

    public onResult():void{
        // if(!SanQuentin2.setupPhase.waitingForRes)
        this.state.set(this._finished ? SetupPhases.OUTRO : SetupPhases.ROUND_WON);
        if(this._gameData.Win.brokeTheBank){
            this.timeline.add(SanQuentin2.setupPhase.onGambleCapWon());
            this.setPlayable(false);
        }else{
            this.timeline.add(SanQuentin2.setupPhase.ShowClickResult());
        }
    }

    public onNext():void{
        SanEngineManager.RSAll((reel,sym) => {
            this.timeline.add([() => sym.attentionDarkness(), () => sym.setSymbol("X")],0);
        })
        
        SanQuentin2.reelEngineManager.applyBars(false);
        SanQuentin2.reelEngineManager.setFSReelAreaBG(true);
        this.timeline.add(SanQuentin2.setupPhase.NextSetup());
        this.timeline.add(SanQuentin2.reelEngineManager.ZoomIn(false,0.1),0.5);
        this.timeline.add(SanQuentin2.postCounter.playText(GameSetting.translate(TranslationConfig.FREESPINS_COLLECTED) + "\n" + this._gameData.raw.freespinsLeft));
        this.state.set(SetupPhases.BARS_OPEN);
    }

    public onOpenBars():void{
        let del = 0;

        SanEngineManager.RAll((reel) => {
            if(this._gameData.raw.topBottomReelOpened[reel.reelID]){
                this.timeline.add(() => {
                    SoundManager.playSoundEffect(SoundConfig.SETUP_2_DOOR_OPEN)
                }, del)
                this.timeline.add(reel.reelLocker(false), del)
                this.timeline.add(RevealerManager.getTopBar(reel.reelID).openBar(),del)
                this.timeline.add(RevealerManager.getBotBar(reel.reelID).openBar(),del)
            }
            this.timeline.add(() => SanQuentin2.setupPhase.showCaseEnableVal(reel.reelID,this._gameData.raw.topBottomReelOpened[reel.reelID]),del)
            del += 0.2;
        })

      
        this.state.set(SetupPhases.CONVERT);
    }

    public onRoundWon():void{
        this.timeline.to(this,{duration:0.01});
        this.setPlayable(false);
    }

    public onConvert():void{
        this.timeline.to(this,{duration:0.01});
        this.setPlayable(false);
    }

    public done(): void {
    }
}
